import React from "react";
import styled from "@emotion/styled";

const StyledLogo = styled.g`
  color: ${({ theme }) => theme.header};
`;

const StyledFrame = styled.g`
  color: ${({ theme }) => theme.header};
`;

const Logo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 922.5 177.5">
      <StyledLogo id="Logo" fill="currentColor">
        <path
          className="cls-1"
          d="M101.34,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M108.54,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M115.73,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M122.93,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M130.13,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M137.33,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M149.14,56.52v8.35h-.88V57.4h-3.74v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M158.92,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M166.12,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M173.31,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M180.51,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M187.71,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M194.91,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M202.11,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M213.92,56.52v8.35H213V57.4H209.3v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M223.7,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M230.9,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M238.09,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M245.29,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M252.49,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M264.3,56.52v8.35h-.87V57.4h-3.74v-.88Zm-1.75,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M274.08,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M281.28,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M288.48,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M295.68,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M302.87,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M310.07,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M317.27,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M324.47,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M336.28,56.52v8.35h-.88V57.4h-3.74v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M338.86,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M346.06,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M357.87,56.52v8.35H357V57.4h-3.73v-.88Zm-1.75,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M374.85,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M382.05,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M393.86,56.52v8.35H393V57.4h-3.73v-.88Zm-1.76,1.76v6.59h-.87V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M425.23,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M432.43,64.87V50.82H439V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M444.25,56.52v8.35h-.88V57.4h-3.74v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M446.83,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M454,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M461.22,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M473,56.52v8.35h-.88V57.4h-3.74v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M497.21,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M504.41,64.87V50.82H511V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M516.22,56.52v8.35h-.88V57.4h-3.73v-.88Zm-1.76,1.76v6.59h-.87V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M547.59,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M554.79,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M562,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M569.19,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M576.38,64.87V50.82H583V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M583.58,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M590.78,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M602.59,56.52v8.35h-.88V57.4H598v-.88Zm-1.75,1.76v6.59H600V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M605.17,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M612.37,64.87V50.82H619V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M619.57,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M626.77,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M634,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M641.16,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M653,56.52v8.35h-.88V57.4h-3.74v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M670,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M677.15,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M684.35,64.87V50.82H691V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M691.55,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M698.74,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M710.56,56.52v8.35h-.88V57.4h-3.74v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M727.53,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M734.73,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M741.93,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M749.13,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M756.33,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M763.52,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M775.34,56.52v8.35h-.88V57.4h-3.74v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M777.92,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M785.12,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M792.31,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M799.51,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M806.71,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M813.91,64.87V50.82h6.59V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M821.1,64.87V50.82h6.6V64.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M832.92,56.52v8.35H832V57.4H828.3v-.88Zm-1.76,1.76v6.59h-.88V59.16h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M101.34,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M108.54,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M122.33,70.92v.88h-3.74v7.47h-.88V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M122.93,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M130.13,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M137.33,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M144.52,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M156.34,70.92v8.35h-.88V71.8h-3.74v-.88Zm-1.76,1.76v6.59h-.88V73.56h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M158.92,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M166.12,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M179.91,70.92v.88h-3.74v7.47h-.87V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M180.51,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M187.71,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M194.91,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M202.11,70.92h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M209.3,73.56v-.88H213V65.22h.88v8.34Zm2.86-1.76H209.3v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M216.5,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M223.7,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M237.49,70.92v.88h-3.73v7.47h-.88V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M238.09,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M245.29,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M252.49,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M259.69,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M271.5,70.92v8.35h-.88V71.8h-3.74v-.88Zm-1.76,1.76v6.59h-.88V73.56h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M276.06,73.56V65.22h.88v7.46h3.74v.88Zm1.76-1.76V65.22h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M281.28,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M288.48,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M295.68,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M302.87,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M316.67,70.92v.88h-3.74v7.47h-.88V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M317.27,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M324.47,70.92h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M331.66,73.56v-.88h3.74V65.22h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M338.86,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M346.06,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M355.24,65.22h.88v14h-.88Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M374.85,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M382.05,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M391.23,65.22h.87v14h-.87Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M425.23,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M432.43,79.27v-14H439v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M441.61,65.22h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M446.83,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M454,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M461.22,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M468.42,79.27v-14H475v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M480.23,70.92v8.35h-.87V71.8h-3.74v-.88Zm-1.75,1.76v6.59h-.88V73.56h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M497.21,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M504.41,79.27v-14H511v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M513.59,65.22h.87v14h-.87Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M547.59,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M554.79,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M568.59,70.92v.88h-3.74v7.47H564V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M569.19,70.92h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M576.38,70.92H583v.88h-6.6Zm0,1.76H583v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M583.58,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M590.78,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M598,73.56v-.88h3.73V65.22h.88v8.34Zm2.86-1.76H598v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M605.17,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M612.37,79.27v-14H619v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M626.17,70.92v.88h-3.74v7.47h-.88V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M626.77,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M634,70.92h6.6v.88H634Zm0,1.76h6.6v.88H634Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M641.16,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M648.36,79.27v-14H655v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M660.17,70.92v8.35h-.87V71.8h-3.74v-.88Zm-1.75,1.76v6.59h-.88V73.56h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M662.76,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M670,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M683.75,70.92v.88H680v7.47h-.88V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M684.35,70.92H691v.88h-6.6Zm0,1.76H691v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M691.55,70.92h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M698.74,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M705.94,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M717.76,70.92v8.35h-.88V71.8h-3.74v-.88ZM716,72.68v6.59h-.88V73.56h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M720.34,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M727.53,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M741.33,70.92v.88h-3.74v7.47h-.88V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M741.93,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M749.13,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M756.33,70.92h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M763.52,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M770.72,73.56v-.88h3.74V65.22h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M777.92,79.27v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M785.12,79.27v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M798.91,70.92v.88h-3.74v7.47h-.88V70.92Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M799.51,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M806.71,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M813.91,70.92h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M821.1,70.92h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M828.3,73.56v-.88H832V65.22h.88v8.34Zm2.86-1.76H828.3v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M101.34,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M108.54,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M117.71,79.62h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M137.33,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M144.52,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M153.7,79.62h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M158.92,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M166.12,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M173.31,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M180.51,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M187.71,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M199.52,85.32v8.35h-.87V86.2h-3.74v-.88Zm-1.75,1.76v6.59h-.88V88h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M216.5,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M223.7,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M230.9,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M238.09,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M245.29,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M252.49,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M259.69,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M268.86,79.62h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M295.68,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M302.87,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M312.05,79.62h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M338.86,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M346.06,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M353.26,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M360.45,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M367.65,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M374.85,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M382.05,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M391.23,79.62h.87v14h-.87Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M425.23,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M432.43,93.67v-14H439v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M441.61,79.62h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M446.83,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M454,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M467.82,85.32v.88h-3.74v7.47h-.88V85.32ZM465,87.08h2.86V88h-2v5.71H465Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M468.42,93.67v-14H475v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M475.62,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M487.43,85.32v8.35h-.88V86.2h-3.74v-.88Zm-1.76,1.76v6.59h-.88V88h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M497.21,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M504.41,93.67v-14H511v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M513.59,79.62h.87v14h-.87Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M547.59,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M554.79,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M562,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M569.19,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M576.38,93.67v-14H583v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M583.58,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M590.78,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M602.59,85.32v8.35h-.88V86.2H598v-.88Zm-1.75,1.76v6.59H600V88h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M605.17,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M612.37,93.67v-14H619v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M619.57,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M626.77,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M634,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M641.16,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M655,85.32v.88h-3.74v7.47h-.88V85.32Zm-2.86,1.76H655V88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M655.56,88v-.88h3.74V79.62h.87V88Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M662.76,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M670,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M677.15,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M684.35,93.67v-14H691v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M691.55,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M698.74,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M705.94,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M715.12,79.62H716v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M720.34,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M727.53,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M736.71,79.62h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M777.92,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M785.12,93.67v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M792.31,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M799.51,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M806.71,93.67v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M818.52,85.32v8.35h-.88V86.2h-3.73v-.88Zm-1.75,1.76v6.59h-.88V88h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M101.34,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M108.54,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M117.71,94h.88v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M137.33,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M144.52,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M153.7,94h.88v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M158.92,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M166.12,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M179.91,99.72v.88h-3.74v7.47h-.87V99.72Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M180.51,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M187.71,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M194.91,102.36v-.88h3.74V94h.87v8.34Zm2.86-1.76h-2.86v-.88h2V94h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M216.5,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M223.7,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M237.49,99.72v.88h-3.73v7.47h-.88V99.72Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M238.09,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M245.29,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M252.49,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M259.69,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M268.86,94h.88v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M295.68,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M302.87,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M312.05,94h.88v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M338.86,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M346.06,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M359.85,99.72v.88h-3.73v7.47h-.88V99.72ZM357,101.48h2.86v.88h-2v5.71H357Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M360.45,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M367.65,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M374.85,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M382.05,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M391.23,94h.87v14h-.87Zm1.75,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M425.23,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M432.43,108.07V94H439v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M441.61,94h.88v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M446.83,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M454,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M463.2,94h.88v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M470.4,102.36V94h.88v7.46H475v.88Zm1.76-1.76V94H473v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M475.62,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M482.81,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M494.63,99.72v8.35h-.88V100.6H490v-.88Zm-1.76,1.76v6.59H492v-5.71h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M497.21,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M504.41,108.07V94H511v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M513.59,94h.87v14h-.87Zm1.75,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M549.57,102.36V94h.88v7.46h3.74v.88Zm1.76-1.76V94h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M554.79,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M562,99.72h6.6v.88H562Zm0,1.76h6.6v.88H562Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M569.19,99.72h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M576.38,99.72H583v.88h-6.6Zm0,1.76H583v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M583.58,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M590.78,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M600,94h.88v14H600Zm1.75,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M605.17,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M612.37,108.07V94H619v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M626.17,99.72v.88h-3.74v7.47h-.88V99.72Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M626.77,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M634,99.72h6.6v.88H634Zm0,1.76h6.6v.88H634Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M641.16,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M648.36,102.36v-.88h3.74V94H653v8.34Zm2.86-1.76h-2.86v-.88h2V94h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M662.76,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M670,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M683.75,99.72v.88H680v7.47h-.88V99.72Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M684.35,99.72H691v.88h-6.6Zm0,1.76H691v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M691.55,99.72h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M698.74,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M705.94,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M715.12,94H716v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M720.34,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M727.53,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M736.71,94h.88v14h-.88Zm1.76,14V94h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M777.92,108.07V94h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M785.12,108.07V94h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M798.91,99.72v.88h-3.74v7.47h-.88V99.72Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M799.51,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M806.71,99.72h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M813.91,102.36v-.88h3.73V94h.88v8.34Zm2.86-1.76h-2.86v-.88h2V94h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M101.34,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M108.54,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M115.73,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M122.93,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M130.13,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M137.33,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M151.12,114.12V115h-3.74v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M151.72,116.76v-.88h3.74v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M158.92,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M166.12,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M173.31,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M180.51,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M187.71,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M194.91,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M202.11,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M213.92,114.12v8.35H213V115H209.3v-.88Zm-1.76,1.76v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M216.5,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M223.7,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M232.88,108.42h.88v14h-.88Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M252.49,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M259.69,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M268.86,108.42h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M295.68,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M302.87,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M312.05,108.42h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M338.86,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M346.06,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M355.24,108.42h.88v14h-.88Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M374.85,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M382.05,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M391.23,108.42h.87v14h-.87Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M425.23,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M432.43,122.47v-14H439v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M441.61,108.42h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M446.83,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M454,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M463.2,108.42h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M477.6,116.76v-8.34h.88v7.46h3.73v.88Zm1.76-1.76v-6.58h.87v5.7h2V115Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M482.81,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M490,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M497.21,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M504.41,122.47v-14H511v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M513.59,108.42h.87v14h-.87Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M547.59,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M554.79,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M562,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M569.19,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M576.38,122.47v-14H583v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M583.58,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M590.78,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M600,108.42h.88v14H600Zm1.75,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M605.17,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M612.37,122.47v-14H619v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M621.55,108.42h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M662.76,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M670,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M679.13,108.42H680v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M698.74,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M705.94,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M715.12,108.42H716v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M722.32,116.76v-8.34h.88v7.46h3.73v.88Zm1.76-1.76v-6.58H725v5.7h2V115Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M727.53,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M734.73,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M741.93,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M749.13,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M756.33,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M763.52,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M775.34,114.12v8.35h-.88V115h-3.74v-.88Zm-1.76,1.76v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M777.92,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M785.12,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M792.31,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M799.51,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M806.71,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M813.91,122.47v-14h6.59v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M821.1,122.47v-14h6.6v14Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M832.92,114.12v8.35H832V115H828.3v-.88Zm-1.76,1.76v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M103.32,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58H106v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M108.54,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M115.73,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M122.93,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M130.13,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M137.33,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M144.52,131.16v-.88h3.74v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M160.9,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M166.12,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M173.31,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M180.51,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M187.71,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M194.91,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M202.11,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M209.3,131.16v-.88H213v-7.46h.88v8.34Zm2.86-1.76H209.3v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M218.48,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M223.7,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M230.9,131.16v-.88h3.73v-7.46h.88v8.34Zm2.86-1.76H230.9v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M254.47,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M259.69,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M266.88,131.16v-.88h3.74v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M297.66,131.16v-8.34h.87v7.46h3.74v.88Zm1.75-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M302.87,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M310.07,131.16v-.88h3.74v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M340.84,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M346.06,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M353.26,131.16v-.88H357v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M376.83,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M382.05,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M389.25,131.16v-.88H393v-7.46h.88v8.34Zm2.85-1.76h-2.85v-.88h2v-5.7h.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M427.21,131.16v-8.34h.88v7.46h3.74v.88ZM429,129.4v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M432.43,128.52H439v.88h-6.6Zm0,1.76H439v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M439.63,131.16v-.88h3.74v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M448.81,131.16v-8.34h.88v7.46h3.73v.88Zm1.75-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M454,128.52h6.6v.88H454Zm0,1.76h6.6v.88H454Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M461.22,131.16v-.88H465v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M484.79,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M490,128.52h6.6v.88H490Zm0,1.76h6.6v.88H490Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M497.21,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M504.41,128.52H511v.88h-6.59Zm0,1.76H511v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M511.61,131.16v-.88h3.73v-7.46h.88v8.34Zm2.85-1.76h-2.85v-.88h2v-5.7h.87Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M549.57,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M554.79,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M562,128.52h6.6v.88H562Zm0,1.76h6.6v.88H562Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M569.19,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M576.38,128.52H583v.88h-6.6Zm0,1.76H583v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M583.58,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M590.78,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M598,131.16v-.88h3.73v-7.46h.88v8.34Zm2.86-1.76H598v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M607.16,131.16v-8.34H608v7.46h3.74v.88Zm1.75-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M612.37,128.52H619v.88h-6.6Zm0,1.76H619v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M619.57,131.16v-.88h3.74v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M664.74,131.16v-8.34h.88v7.46h3.73v.88Zm1.75-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M670,128.52h6.6v.88H670Zm0,1.76h6.6v.88H670Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M677.15,131.16v-.88h3.74v-7.46h.88v8.34ZM680,129.4h-2.86v-.88h2v-5.7H680Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M700.72,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M705.94,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M713.14,131.16v-.88h3.74v-7.46h.88v8.34ZM716,129.4h-2.86v-.88h2v-5.7H716Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M729.51,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M734.73,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M741.93,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M749.13,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M756.33,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M763.52,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M770.72,131.16v-.88h3.74v-7.46h.88v8.34Zm2.86-1.76h-2.86v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M779.9,131.16v-8.34h.88v7.46h3.74v.88Zm1.76-1.76v-6.58h.88v5.7h2v.88Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M785.12,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M792.31,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M799.51,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M806.71,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M813.91,128.52h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M821.1,128.52h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-1"
          d="M828.3,131.16v-.88H832v-7.46h.88v8.34Zm2.86-1.76H828.3v-.88h2v-5.7h.88Z"
          transform="translate(-7 -2.45)"
        />
      </StyledLogo>
      <StyledFrame id="Frame" fill="currentColor">
        <path
          className="cls-2"
          d="M8.5,13v-1.5H7V10H8.5V5.45H7V4H8.5V2.45h3V4H13V2.45h3V4h1.5v1.5H16V10h1.5v1.5H16V13H13v-1.5H11.5V13Zm3-3H13V5.45H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M32.5,13v-1.5H31V10h1.5V5.45H31V4h1.5V2.45h3V4H37V2.45h3V4h1.5v1.5H40V10h1.5v1.5H40V13H37v-1.5H35.5V13Zm3-3H37V5.45H35.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M56.5,13v-1.5H55V10h1.5V5.45H55V4h1.5V2.45h3V4H61V2.45h3V4h1.5v1.5H64V10h1.5v1.5H64V13H61v-1.5H59.5V13Zm3-3H61V5.45H59.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M80.5,13v-1.5H79V10h1.5V5.45H79V4h1.5V2.45h3V4H85V2.45h3V4h1.5v1.5H88V10h1.5v1.5H88V13H85v-1.5H83.5V13Zm3-3H85V5.45H83.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M104.5,13v-1.5H103V10h1.5V5.45H103V4h1.5V2.45h3V4H109V2.45h3V4h1.5v1.5H112V10h1.5v1.5H112V13h-3v-1.5h-1.5V13Zm3-3H109V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M128.5,13v-1.5H127V10h1.5V5.45H127V4h1.5V2.45h3V4H133V2.45h3V4h1.5v1.5H136V10h1.5v1.5H136V13h-3v-1.5h-1.5V13Zm3-3H133V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M152.5,13v-1.5H151V10h1.5V5.45H151V4h1.5V2.45h3V4H157V2.45h3V4h1.5v1.5H160V10h1.5v1.5H160V13h-3v-1.5h-1.5V13Zm3-3H157V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M176.5,13v-1.5H175V10h1.5V5.45H175V4h1.5V2.45h3V4H181V2.45h3V4h1.5v1.5H184V10h1.5v1.5H184V13h-3v-1.5h-1.5V13Zm3-3H181V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M200.5,13v-1.5H199V10h1.5V5.45H199V4h1.5V2.45h3V4H205V2.45h3V4h1.5v1.5H208V10h1.5v1.5H208V13h-3v-1.5h-1.5V13Zm3-3H205V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M224.5,13v-1.5H223V10h1.5V5.45H223V4h1.5V2.45h3V4H229V2.45h3V4h1.5v1.5H232V10h1.5v1.5H232V13h-3v-1.5h-1.5V13Zm3-3H229V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M263.5,11.45v-3h-3V7h3V4h3V7h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M287.5,11.45v-3h-3V7h3V4h3V7h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M311.5,11.45v-3h-3V7h3V4h3V7h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M343,13V5.45h1.5V4H346V2.45h4.5V4H352v1.5h1.5V13h-3V10H346v3Zm3-4.5h4.5v-3H349V4h-1.5v1.5H346Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M370,13v-1.5h-1.5V10H367V5.45h1.5V4H370V2.45h6V4h1.5v1.5h-3V4h-3v1.5H370V10h1.5v1.5h3V10h3v1.5H376V13Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M379,13V2.45h3V7h4.5V2.45h3V13h-3V8.45H382V13Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M391,13V5.45h1.5V4H394V2.45h4.5V4H400v1.5h1.5V13h-3V10H394v3Zm3-4.5h4.5v-3H397V4h-1.5v1.5H394Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M403,13V2.45h9V4h1.5v4.5h-3V10H412v1.5h1.5V13H409v-1.5h-1.5V10H406v3Zm3-4.5h3V7h1.5V4H406Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M415,13V5.45h1.5V4H418V2.45h4.5V4H424v1.5h1.5V13h-3V10H418v3Zm3-4.5h4.5v-3H421V4h-1.5v1.5H418Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M430,13v-1.5h-1.5V10H427V5.45h1.5V4H430V2.45h6V4h1.5v1.5h-3V4h-3v1.5H430V10h1.5v1.5h3V10h3v1.5H436V13Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M443.5,13V4h-3V2.45h9V4h-3v9Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M451,13V2.45h10.5V4H454V7h6v1.5h-6v3h7.5V13Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M463,13V2.45h9V4h1.5v4.5h-3V10H472v1.5h1.5V13H469v-1.5h-1.5V10H466v3Zm3-4.5h3V7h1.5V4H466Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M490,13v-1.5h-1.5V10H487V5.45h1.5V4H490V2.45h7.5V4h-6v1.5H490V10h1.5v1.5h3v-3H493V7h4.5v6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M499,13V2.45h10.5V4H502V7h6v1.5h-6v3h7.5V13Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M511,13V2.45h3V4h1.5v1.5H517V7h1.5V2.45h3V13h-3V10H517V8.45h-1.5V7H514v6Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M523,13V2.45h10.5V4H526V7h6v1.5h-6v3h7.5V13Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M535,13V2.45h9V4h1.5v4.5h-3V10H544v1.5h1.5V13H541v-1.5h-1.5V10H538v3Zm3-4.5h3V7h1.5V4H538Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M547,13V5.45h1.5V4H550V2.45h4.5V4H556v1.5h1.5V13h-3V10H550v3Zm3-4.5h4.5v-3H553V4h-1.5v1.5H550Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M563.5,13V4h-3V2.45h9V4h-3v9Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M572.5,13v-1.5H571V4h1.5V2.45H580V4h1.5v7.5H580V13Zm1.5-1.5h4.5V4H574Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M583,13V2.45h9V4h1.5v4.5h-3V10H592v1.5h1.5V13H589v-1.5h-1.5V10H586v3Zm3-4.5h3V7h1.5V4H586Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M623.5,11.45v-3h-3V7h3V4h3V7h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M647.5,11.45v-3h-3V7h3V4h3V7h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M671.5,11.45v-3h-3V7h3V4h3V7h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M704.5,13v-1.5H703V10h1.5V5.45H703V4h1.5V2.45h3V4H709V2.45h3V4h1.5v1.5H712V10h1.5v1.5H712V13h-3v-1.5h-1.5V13Zm3-3H709V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M728.5,13v-1.5H727V10h1.5V5.45H727V4h1.5V2.45h3V4H733V2.45h3V4h1.5v1.5H736V10h1.5v1.5H736V13h-3v-1.5h-1.5V13Zm3-3H733V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M752.5,13v-1.5H751V10h1.5V5.45H751V4h1.5V2.45h3V4H757V2.45h3V4h1.5v1.5H760V10h1.5v1.5H760V13h-3v-1.5h-1.5V13Zm3-3H757V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M776.5,13v-1.5H775V10h1.5V5.45H775V4h1.5V2.45h3V4H781V2.45h3V4h1.5v1.5H784V10h1.5v1.5H784V13h-3v-1.5h-1.5V13Zm3-3H781V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M800.5,13v-1.5H799V10h1.5V5.45H799V4h1.5V2.45h3V4H805V2.45h3V4h1.5v1.5H808V10h1.5v1.5H808V13h-3v-1.5h-1.5V13Zm3-3H805V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M824.5,13v-1.5H823V10h1.5V5.45H823V4h1.5V2.45h3V4H829V2.45h3V4h1.5v1.5H832V10h1.5v1.5H832V13h-3v-1.5h-1.5V13Zm3-3H829V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M848.5,13v-1.5H847V10h1.5V5.45H847V4h1.5V2.45h3V4H853V2.45h3V4h1.5v1.5H856V10h1.5v1.5H856V13h-3v-1.5h-1.5V13Zm3-3H853V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M872.5,13v-1.5H871V10h1.5V5.45H871V4h1.5V2.45h3V4H877V2.45h3V4h1.5v1.5H880V10h1.5v1.5H880V13h-3v-1.5h-1.5V13Zm3-3H877V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M896.5,13v-1.5H895V10h1.5V5.45H895V4h1.5V2.45h3V4H901V2.45h3V4h1.5v1.5H904V10h1.5v1.5H904V13h-3v-1.5h-1.5V13Zm3-3H901V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,13v-1.5H919V10h1.5V5.45H919V4h1.5V2.45h3V4H925V2.45h3V4h1.5v1.5H928V10h1.5v1.5H928V13h-3v-1.5h-1.5V13Zm3-3H925V5.45h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,180v-1.5H7V177H8.5v-4.5H7V171H8.5v-1.5h3V171H13v-1.5h3V171h1.5v1.5H16V177h1.5v1.5H16V180H13v-1.5H11.5V180Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M32.5,180v-1.5H31V177h1.5v-4.5H31V171h1.5v-1.5h3V171H37v-1.5h3V171h1.5v1.5H40V177h1.5v1.5H40V180H37v-1.5H35.5V180Zm3-3H37v-4.5H35.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M56.5,180v-1.5H55V177h1.5v-4.5H55V171h1.5v-1.5h3V171H61v-1.5h3V171h1.5v1.5H64V177h1.5v1.5H64V180H61v-1.5H59.5V180Zm3-3H61v-4.5H59.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M80.5,180v-1.5H79V177h1.5v-4.5H79V171h1.5v-1.5h3V171H85v-1.5h3V171h1.5v1.5H88V177h1.5v1.5H88V180H85v-1.5H83.5V180Zm3-3H85v-4.5H83.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M104.5,180v-1.5H103V177h1.5v-4.5H103V171h1.5v-1.5h3V171H109v-1.5h3V171h1.5v1.5H112V177h1.5v1.5H112V180h-3v-1.5h-1.5V180Zm3-3H109v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M128.5,180v-1.5H127V177h1.5v-4.5H127V171h1.5v-1.5h3V171H133v-1.5h3V171h1.5v1.5H136V177h1.5v1.5H136V180h-3v-1.5h-1.5V180Zm3-3H133v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M152.5,180v-1.5H151V177h1.5v-4.5H151V171h1.5v-1.5h3V171H157v-1.5h3V171h1.5v1.5H160V177h1.5v1.5H160V180h-3v-1.5h-1.5V180Zm3-3H157v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M176.5,180v-1.5H175V177h1.5v-4.5H175V171h1.5v-1.5h3V171H181v-1.5h3V171h1.5v1.5H184V177h1.5v1.5H184V180h-3v-1.5h-1.5V180Zm3-3H181v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M200.5,180v-1.5H199V177h1.5v-4.5H199V171h1.5v-1.5h3V171H205v-1.5h3V171h1.5v1.5H208V177h1.5v1.5H208V180h-3v-1.5h-1.5V180Zm3-3H205v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M224.5,180v-1.5H223V177h1.5v-4.5H223V171h1.5v-1.5h3V171H229v-1.5h3V171h1.5v1.5H232V177h1.5v1.5H232V180h-3v-1.5h-1.5V180Zm3-3H229v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M263.5,178.45v-3h-3V174h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M287.5,178.45v-3h-3V174h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M311.5,178.45v-3h-3V174h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M344.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M356.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M368.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M380.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M392.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M404.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M416.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M428.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M440.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M452.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M464.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M476.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M488.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M500.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M512.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M524.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M536.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M548.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M560.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M572.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M584.5,175.45V174h9v1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M623.5,178.45v-3h-3V174h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M647.5,178.45v-3h-3V174h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M671.5,178.45v-3h-3V174h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M704.5,180v-1.5H703V177h1.5v-4.5H703V171h1.5v-1.5h3V171H709v-1.5h3V171h1.5v1.5H712V177h1.5v1.5H712V180h-3v-1.5h-1.5V180Zm3-3H709v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M728.5,180v-1.5H727V177h1.5v-4.5H727V171h1.5v-1.5h3V171H733v-1.5h3V171h1.5v1.5H736V177h1.5v1.5H736V180h-3v-1.5h-1.5V180Zm3-3H733v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M752.5,180v-1.5H751V177h1.5v-4.5H751V171h1.5v-1.5h3V171H757v-1.5h3V171h1.5v1.5H760V177h1.5v1.5H760V180h-3v-1.5h-1.5V180Zm3-3H757v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M776.5,180v-1.5H775V177h1.5v-4.5H775V171h1.5v-1.5h3V171H781v-1.5h3V171h1.5v1.5H784V177h1.5v1.5H784V180h-3v-1.5h-1.5V180Zm3-3H781v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M800.5,180v-1.5H799V177h1.5v-4.5H799V171h1.5v-1.5h3V171H805v-1.5h3V171h1.5v1.5H808V177h1.5v1.5H808V180h-3v-1.5h-1.5V180Zm3-3H805v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M824.5,180v-1.5H823V177h1.5v-4.5H823V171h1.5v-1.5h3V171H829v-1.5h3V171h1.5v1.5H832V177h1.5v1.5H832V180h-3v-1.5h-1.5V180Zm3-3H829v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M848.5,180v-1.5H847V177h1.5v-4.5H847V171h1.5v-1.5h3V171H853v-1.5h3V171h1.5v1.5H856V177h1.5v1.5H856V180h-3v-1.5h-1.5V180Zm3-3H853v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M872.5,180v-1.5H871V177h1.5v-4.5H871V171h1.5v-1.5h3V171H877v-1.5h3V171h1.5v1.5H880V177h1.5v1.5H880V180h-3v-1.5h-1.5V180Zm3-3H877v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M896.5,180v-1.5H895V177h1.5v-4.5H895V171h1.5v-1.5h3V171H901v-1.5h3V171h1.5v1.5H904V177h1.5v1.5H904V180h-3v-1.5h-1.5V180Zm3-3H901v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,180v-1.5H919V177h1.5v-4.5H919V171h1.5v-1.5h3V171H925v-1.5h3V171h1.5v1.5H928V177h1.5v1.5H928V180h-3v-1.5h-1.5V180Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,30.55v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,45v-1.5H7V42H8.5v-4.5H7V36H8.5v-1.5h3V36H13v-1.5h3V36h1.5v1.5H16V42h1.5v1.5H16V45H13v-1.5H11.5V45Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,59.35v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,73.75v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,88.15v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,102.55v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,117v-1.5H7V114H8.5v-4.5H7V108H8.5v-1.5h3V108H13v-1.5h3V108h1.5v1.5H16V114h1.5v1.5H16V117H13v-1.5H11.5V117Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,131.35v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,145.75v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M8.5,160.15v-1.5H7v-1.5H8.5v-4.5H7v-1.5H8.5v-1.5h3v1.5H13v-1.5h3v1.5h1.5v1.5H16v4.5h1.5v1.5H16v1.5H13v-1.5H11.5v1.5Zm3-3H13v-4.5H11.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,30.55v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,45v-1.5H919V42h1.5v-4.5H919V36h1.5v-1.5h3V36H925v-1.5h3V36h1.5v1.5H928V42h1.5v1.5H928V45h-3v-1.5h-1.5V45Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,59.35v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,73.75v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,88.15v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,102.55v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,117v-1.5H919V114h1.5v-4.5H919V108h1.5v-1.5h3V108H925v-1.5h3V108h1.5v1.5H928V114h1.5v1.5H928V117h-3v-1.5h-1.5V117Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,131.35v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,145.75v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
        <path
          className="cls-2"
          d="M920.5,160.15v-1.5H919v-1.5h1.5v-4.5H919v-1.5h1.5v-1.5h3v1.5H925v-1.5h3v1.5h1.5v1.5H928v4.5h1.5v1.5H928v1.5h-3v-1.5h-1.5v1.5Zm3-3H925v-4.5h-1.5Z"
          transform="translate(-7 -2.45)"
        />
      </StyledFrame>
    </svg>
  );
};

export default Logo;
